import { createSlice, PayloadAction, current } from "@reduxjs/toolkit";
import { LABELS } from "./constants";

interface SearchModalStateIF {
  visible: boolean;
  title?: string;
  negativeBtn?: string;
  positiveBtn?: string;
  searchArea: JSX.Element;
  resultArea: JSX.Element;
  selectedItems: any[];
  positiveFn: (items: any[]) => void;
  dismissFn?: VoidFunction;
}

const initialState = {
  visible: false,
  title: LABELS.TITLE,
  negativeBtn: LABELS.CANCEL,
  positiveBtn: LABELS.OK,
} as SearchModalStateIF;

const searchModalSlice = createSlice({
  name: "searchModal",
  initialState,
  reducers: {
    showSearchModal: (
      state,
      action: PayloadAction<{
        title?: string;
        negativeBtn?: string;
        positiveBtn?: string;
        searchArea: JSX.Element;
        resultArea: JSX.Element;
        positiveFn: (items: any[]) => void;
        dismissFn?: VoidFunction;
      }>
    ) => ({ ...current(state), ...action.payload, visible: true }),
    setItems: (
      state,
      action: PayloadAction<{
        items: any[];
      }>
    ) => {
      const { items } = action.payload;
      state.selectedItems = items;
    },
    dismissSearchModal: () => ({ ...initialState }),
  },
});

export const { showSearchModal, setItems, dismissSearchModal } =
  searchModalSlice.actions;

export default searchModalSlice.reducer;
